import React, { useEffect } from 'react';

import { Platform } from 'react-native';

import { useDispatch } from 'react-redux';

import { useNavigation } from '@react-navigation/native';
import {
    StackNavigationProp,
    createStackNavigator,
} from '@react-navigation/stack';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import PinSetupNavigator from 'router/PinSetupNavigator';
import { SCREEN } from 'router/screens';

import { setTimer } from 'store/timer/actions';

import { navigationService } from 'utils/NavigationService';
import useLogAppStateChange from 'utils/hooks/useLogAppStateChange';
import { isTablet, isWeb } from 'utils/responsiveness';

import FtiTutorial from 'screens/FtiTutorial';
import LandingScreen from 'screens/Landing';
import LoginScreen from 'screens/Login';
import PersonalizeScreen from 'screens/Personalize';
import Profiles from 'screens/Profiles';
import AddProfile from 'screens/Profiles/AddProfile';
import ManageProfile from 'screens/Profiles/ManageProfile';
import ProfileAgeRating from 'screens/Profiles/ProfileAgeRating';
import ProfileAvatarList from 'screens/Profiles/ProfileAvatarList';
import ProfileType from 'screens/Profiles/ProfileType';
import QRLoginScreen from 'screens/QRLogin';
import Splash from 'screens/Splash';
import WelcomeScreen from 'screens/Welcome';

import TabNavigator from './TabNavigator';
import { RouteNavigationParams } from './types';

const {
    PROFILE: {
        PROFILE_AGE_RATING_OVERLAY_TITLE,
        PROFILE_AVATAR_COLLECTION_TITLE,
    },
} = LANGUAGE_KEYS;

const Stack = createStackNavigator();
const screenOptions: {} = {
    gestureEnabled: false,
    headerShown: false,
};
const profileOptions: {} = {
    gestureEnabled: Platform.OS === 'ios',
};

function RootNavigator() {
    const navigation =
        useNavigation<StackNavigationProp<RouteNavigationParams>>();
    const dispatch = useDispatch();

    useLogAppStateChange();

    useEffect(() => {
        navigationService.setNavigation(navigation);
    }, []);

    useEffect(() => {
        setInterval(() => {
            dispatch(setTimer());
        }, 5000);
    }, []);

    return (
        <>
            <Stack.Navigator
                screenOptions={screenOptions}
                initialRouteName={SCREEN.SPLASH_SCREEN}
            >
                <Stack.Screen name={SCREEN.SPLASH_SCREEN} component={Splash} />
                <Stack.Screen
                    name={SCREEN.WELCOME_SCREEN}
                    component={WelcomeScreen}
                />
                <Stack.Screen
                    name={SCREEN.LANDING_SCREEN}
                    component={LandingScreen}
                />
                <Stack.Screen
                    name={SCREEN.LOGIN_SCREEN}
                    component={LoginScreen}
                />
                <Stack.Screen
                    name={SCREEN.QR_LOGIN_SCREEN}
                    component={QRLoginScreen}
                />
                <Stack.Screen
                    name={SCREEN.FTI_TUTORIAL}
                    component={FtiTutorial}
                />
                <Stack.Screen
                    name={SCREEN.PERSONALIZE_SCREEN}
                    /* @ts-ignore */
                    component={PersonalizeScreen}
                />
                <Stack.Screen name={SCREEN.ROOT} component={TabNavigator} />
                <Stack.Screen
                    name={SCREEN.PIN_SETUP}
                    component={PinSetupNavigator}
                />
                <Stack.Screen
                    name={SCREEN.PROFILES}
                    component={Profiles}
                    options={profileOptions}
                />
                <Stack.Screen
                    name={SCREEN.PROFILE_TYPE}
                    component={ProfileType}
                    options={profileOptions}
                />
                <Stack.Screen
                    name={SCREEN.ADD_PROFILE}
                    // @ts-ignore
                    component={AddProfile}
                    options={profileOptions}
                />
                <Stack.Screen
                    options={{ headerShown: isTablet, ...profileOptions }}
                    initialParams={{
                        title: PROFILE_AGE_RATING_OVERLAY_TITLE,
                        shouldSetAccessibilityFocus: true,
                    }}
                    name={SCREEN.PROFILE_AGE_RATING}
                    // @ts-ignore
                    component={ProfileAgeRating}
                />
                <Stack.Screen
                    options={{ headerShown: !isWeb, ...profileOptions }}
                    initialParams={{
                        title: PROFILE_AVATAR_COLLECTION_TITLE,
                        shouldSetAccessibilityFocus: true,
                    }}
                    name={SCREEN.PROFILE_AVATARS}
                    // @ts-ignore
                    component={ProfileAvatarList}
                />
                <Stack.Screen
                    name={SCREEN.MANAGE_PROFILE}
                    /* @ts-ignore */
                    component={ManageProfile}
                    options={profileOptions}
                />
            </Stack.Navigator>
        </>
    );
}

export default RootNavigator;
